import styled from 'styled-components';
import BackgroundImage from 'gatsby-background-image';
import { Grid } from '@carvana/showroom-grid';
import { getMediaQuery } from '@carvana/showroom-theme';

export const HeroWrapper = styled.div`
  position: relative;
  z-index: 1;
  height: ${(props) => (props.isUserLoggedIn ? 16 : 27)}rem;

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    min-height: 10rem;
    height: unset;
  }
`;

export const HeroBackground = styled(BackgroundImage)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  background-size: cover;
  background-position: center;
  color: ${(props) => props.theme.color.neutral.v100};
  background-color: ${(props) => props.theme.color.primary.v600};

  height: ${(props) => (props.isUserLoggedIn ? 250 : 260)}px;

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    height: ${(props) => (props.isUserLoggedIn ? 260 : 358)}px;
  }
`;

export const HeroTitle = styled.div`
  font-size: 28px;
  text-transform: uppercase;
  padding: 3.5rem 5px 1rem;
  font-weight: 700;
  text-align: center;

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    font-size: 36px;
  }
`;

export const StyledSearchContainer = styled(Grid)`
  max-width: 500px;
  width: 100%;
  padding-left: 24px;
  padding-right: 24px;
  display: block;
`;

export const SmallSeparator = styled.hr`
  border-top: 1px solid ${(props) => props.theme.color.neutral.v300};
  width: 90%;

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    visibility: hidden;
    margin: 0rem;
  }
`;
